var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"success","size":"small","loading":_vm.loading},on:{"click":_vm.sync}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }